const Condition = require( './Condition' );
const BattleCalc = require( '../BattleCalc' );

const BlessedCondition = function( instigator, owner, battleState, potency, duration ) {
	const condition = new Condition( instigator, owner, battleState, potency );
	condition.handle = 'blessed';

	const extant = BattleCalc.getCondition( owner, 'blessed' );
	if( extant ) {
		battleState.expireCondition( extant.uid );
	}

	condition.initInterval( condition.expire, duration );
	if( battleState.paused ) {
		condition.intervalTimer.pause();
	}

	return condition;
};
module.exports = BlessedCondition
